




































import {Component, Mixins, Prop, Watch} from 'vue-property-decorator';
import bookingDefault from '@/instance-defaults/bookingDefault';
import HourPicker from '@/components/Views/Booking Flow/HourPicker.vue';
import {multiNil, nil} from '@/common';
import {DateTime} from 'luxon';
import TimePicker from '@/components/Views/UI/TimePicker.vue';
import GlobalAlertMixin from '@/mixins/GlobalAlertMixin.vue';
import BookingCalculateCheckInOutMixin from '@/mixins/BookingCalculateCheckInOutMixin.vue';
import {getZonedBookingDate} from '@/utils';
import BookingDateMixin from '@/mixins/BookingDateMixin.vue';

@Component({
    components: {
        TimePicker,
        HourPicker,
    },
})
export default class ChangeBookingCheckInOut extends Mixins(GlobalAlertMixin, BookingCalculateCheckInOutMixin, BookingDateMixin) {

    public loading = false;
    public errors = [];

    public checkIn = null;
    public checkOut = null;
    public checkInEnabled = false;
    public checkOutEnabled = false;
    private panelOpen = null;

    @Prop({default: () => bookingDefault})
    public booking!: any;

    @Prop({default: true})
    public popin!: boolean;

    @Watch('booking')
    public onBookingChanged(value: any, oldValue: any) {
        this.loadFromBooking();
    }
    get adminCheckInText() {
        return this.checkedIn ? `Checked In ${this.friendlyCheckInOutTime(this.booking.checkInTime)}` : 'No Check In';
    }
    get adminCheckOutText() {
        return this.checkedOut ? `Checked Out ${this.friendlyCheckInOutTime(this.booking.checkOutTime)}` : 'No Check Out';
    }
    get checkedIn() {
        if (nil(this.booking)) {
            return false;
        }
        return !nil(this.booking.checkInTime);
    }

    get checkedOut() {
        if (nil(this.booking)) {
            return false;
        }
        return !nil(this.booking.checkOutTime);
    }
    public mounted() {
        this.loadFromBooking();
    }
    public created() {
        this.loadFromBooking();
    }

    public loadFromBooking() {
        this.checkIn = null;
        this.checkOut = null;
        this.checkInEnabled = false;
        this.checkOutEnabled = false;
        if (nil(this.booking)) {
            return;
        }
        if (!multiNil(this, 'booking.checkInTime')) {
            this.checkInEnabled = true;
            this.checkIn = DateTime.fromISO(this.booking.checkInTime).toLocaleString({
                hour: '2-digit',
                minute: '2-digit',
                hour12: false,
            });
        }
        if (!multiNil(this, 'booking.checkOutTime')) {
            this.checkOutEnabled = true;
            this.checkOut = DateTime.fromISO(this.booking.checkOutTime).toLocaleString({
                hour: '2-digit',
                minute: '2-digit',
                hour12: false,
            });
        }
    }
    @Watch('checkIn')
    public onCheckInChanged(value: string, oldValue: string) {
        this.checkValidCheckInOut();
    }
    @Watch('checkOut')
    public onCheckOutChanged(value: string, oldValue: string) {
        this.checkValidCheckInOut();
    }
    @Watch('checkInEnabled')
    public onCheckInEnabledChanged(value: boolean, oldValue: boolean) {
        setTimeout(() => {
            this.checkValidCheckInOut();
        }, 250);
    }
    @Watch('checkOutEnabled')
    public onCheckOutEnabledChanged(value: boolean, oldValue: boolean) {
        setTimeout(() => {
            this.checkValidCheckInOut();
        }, 250);
    }

    public checkValidCheckInOut() {
        this.errors = [];
        const errorsNew = [];
        let ci = null;
        let co = null;
        if (this.checkInEnabled) {
            ci = DateTime.fromObject({
                hour: this.checkInAsLocalDateTime.hour,
                minute: this.checkInAsLocalDateTime.minute,
            });
            const checkInValid = this.timeIsWithinMinutesOfOtherTime(ci, DateTime.fromObject({
                hour: this.expectedZonedCheckInTime.hour,
                minute: this.expectedZonedCheckInTime.minute,
            }), this.checkInBuffer);
            if (checkInValid !== 0) {
                errorsNew.push(`Check in is too ${checkInValid > 0 ? 'late' : 'early'}`);
            }
        }
        if (this.checkOutEnabled) {
            co = DateTime.fromObject({
                hour: this.checkOutAsLocalDateTime.hour,
                minute: this.checkOutAsLocalDateTime.minute,
            });
            const checkOutValid = this.timeIsWithinMinutesOfOtherTime(co, DateTime.fromObject({
                hour: this.expectedZonedCheckOutTime.hour,
                minute: this.expectedZonedCheckOutTime.minute,
            }), this.checkInBuffer);
            if (checkOutValid !== 0) {
                errorsNew.push(`Check out is too ${checkOutValid > 0 ? 'late' : 'early'}`);
            }
        }
        if (!nil(ci) && !nil(co)) {
            if (ci > co) {
                errorsNew.push('Check in occurs after check out');
            } else if (ci === co) {
                errorsNew.push('Check in and out cannot be the same time');
            }
        }
        this.errors = errorsNew;
    }
    get localCheckIn(){
        if(nil(this.booking) || nil(this.booking.date) || nil(this.checkIn)) return '';
        const time = DateTime.fromFormat(this.checkIn, "HH:mm");
        return this.zonedBookingDate.set({
            hour:time.hour,
            minute:time.minute,
        }).toLocal().toFormat("hh:mm a (z)")
    }
    get localCheckOut(){
        if(nil(this.booking) || nil(this.booking.date) || nil(this.checkOut)) return '';
        const time = DateTime.fromFormat(this.checkOut, "HH:mm");
        return this.zonedBookingDate.set({
            hour:time.hour,
            minute:time.minute,
        }).toLocal().toFormat("hh:mm a (z)")
    }

    public async performUpdate() {
        if (this.checkInEnabled) {
            this.booking.checkInTime = this.checkInAsLocalDateTime.toISO();
        } else {
            this.booking.checkInTime = null;
        }
        if (this.checkOutEnabled) {
            this.booking.checkOutTime = this.checkOutAsLocalDateTime.toISO();
        } else {
            this.booking.checkOutTime = null;
        }
        try {
            await this.booking.save();
            this.showAlert('Updated Check In/Out Times', 'success');
            this.$emit('onSave');
            this.panelOpen = null;
        } catch (e) {
            this.showAlert('Failed updating Check In/Out Times', 'error');
        }
    }

    public get checkInAsLocalDateTime() {
        const cid = DateTime.fromFormat(this.checkIn, 'HH:mm').toLocal();
        return this.localBookingDate.set({hour: cid.hour, minute: cid.minute});
    }
    public get checkOutAsLocalDateTime() {
        const cod = DateTime.fromFormat(this.checkOut, 'HH:mm').toLocal();
        return this.localBookingDate.set({hour: cod.hour, minute: cod.minute});
    }

    public get checkInAsZonedDateTime() {
        const cid = DateTime.fromFormat(this.checkIn, 'HH:mm').toLocal();
        return this.zonedBookingDate.set({hour: cid.hour, minute: cid.minute});
    }
    public get checkOutAsZonedDateTime() {
        const cod = DateTime.fromFormat(this.checkOut, 'HH:mm').toLocal();
        return this.zonedBookingDate.set({hour: cod.hour, minute: cod.minute});
    }

    public get checkInOutStatus() {
        return this.errors.length > 0 ? 'warning' : 'info';
    }
    public get saveText() {
        return `Save${this.errors.length > 0 ? ' Anyway' : ''}`;
    }

}
